import { Component, inject } from '@angular/core';
import { ToastFacade } from 'src/app/_core/state/toasts/toast.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { Toast } from '../../../_core/services/models/toast.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'opac-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  animations: [
    trigger('grow', [
      transition(':enter', [
        style({
          height: 0,
        }),
        animate('.2s ease-out', style({
          height: '*',
        }))
      ]),
      transition(':leave', [
        style({
          height: '*',
          opacity: 0,
        }),
        animate('.2s .2s ease-out', style({
          height: 0,
        })),
      ]),
    ]),
    trigger('visibility', [
      transition(':enter', [
        style({
          transform: 'translateX(calc(100% + 32px))',
        }),
        animate('.2s .2s ease-out', style({
          transform: 'translateX(0)',
        }))
      ]),
      transition(':leave', [
        style({
          opacity: 1,
        }),
        animate('.2s ease-out', style({
          opacity: 0,
        }))
      ])
    ])
  ]
})
export class ToasterComponent {
  private readonly toastFacade = inject(ToastFacade);

  readonly toasts = toSignal(this.toastFacade.toasts$);
  readonly toastsTrackByFn = (_: number, toast: Toast) => toast.id;
}
